export default "__VITE_ASSET__Cn$6MHqp__"